import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { SubMenuItem } from '@shared/components/header-sub-menu/header-sub-menu.component';
import { UserService } from '@shared/services/user.service';

@Component({
	selector: 'app-orderpoc',
	templateUrl: './orderpoc.component.html',
	styleUrls: ['./orderpoc.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class OrderPocComponent {
	private accountId: string = '';

	constructor(
		private router: Router,
		private userService: UserService,
	) {
		this.accountId = this.userService.account.id;
	}

	public favoriteItems: SubMenuItem[] = [
		{
			icon: () => 'acies_add',
			text: () => 'sales.orders.newbtn',
			click: () => this.openConfigureOrder(),
		},
	];

	openConfigureOrder() {
		const url = this.router.serializeUrl(
			this.router.createUrlTree(['/sales/configurator'], {
				queryParams: {
					accountId: this.accountId,
					orderNumber: Date.now(),
				},
			}),
		);
		window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
	}
}
